import {useState, useMemo, useEffect} from "react";
import {Col, Row} from "antd";
import {
	Button,
	StatusLabel,
	Icon
} from "~/components";
import {FileList, FileUpload} from "~/components/Forms";
import {
	renderDate
} from "~/utils";
import {
	useCan
} from "~/hooks";
import _ from "lodash";

function BuyServiceFormInfo({item, modalOpen, onClickStatus, onRemoveFile, onUpload}) {

	const [loadingStatus, setLoadingStatus] = useState({
		success: false,
		cancel: false,
	});

	const can = {
		edit: useCan('buyServiceEdit'),
		status: useCan('buyServiceStatus'),
	};

	let [files, setFiles] = useState([]);

	useEffect(() => {
		if (item?.id) {
			// eslint-disable-next-line react-hooks/exhaustive-deps
			files = [];

			if (!_.isEmpty(item.attachFile)) {
				for (const [path, name] of Object.entries(item.attachFile)) {
					files.push({path, name})
				}
			}

			setFiles(files);
		}
	}, [item]);

	const handleRemoveFileClick = (filename) => {
		setFiles(files.filter(file => file.name !== filename))
		onRemoveFile(filename);
	}
	const handleStatusClick = async (status) => {
		setLoadingStatus(prevState => ({
			...prevState,
			[status]: true
		}));
		if (onClickStatus) {
			await onClickStatus(status, item);
		}
		setLoadingStatus(prevState => ({
			...prevState,
			[status]: false
		}));
	}
	const handleEditClick = () => {
		modalOpen('addEdit');
	}
	const renderFor = (ufor) => {
		if (ufor === 'canhan') {
			return <StatusLabel small type="green">Cá nhân</StatusLabel>
		}
		if (ufor === 'congty') {
			return <StatusLabel small type="blue">Công ty</StatusLabel>
		}

		return <StatusLabel small type="green">Không xác định</StatusLabel>
	}
	const renderCompanyInfo = (item) => {
		return (
			<>
				<p className="heading">Thông tin công ty</p>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Tên công ty</Col>
					<Col className="gutter-row" span={18}>{item.companyName}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Mã số thuế</Col>
					<Col className="gutter-row" span={18}>{item.taxCode}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Địa chỉ</Col>
					<Col className="gutter-row" span={18}>{`${item.companyAddress}, ${item?.companyAddressFull}`}</Col>
				</Row>
			</>
		)
	}
	const renderCustomerInfo = (item) => {
		return (
			<>
				<p className="heading">Thông tin khách hàng</p>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Tên khách hàng</Col>
					<Col className="gutter-row" span={18}>{item.name}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Số CCCD/CMND</Col>
					<Col className="gutter-row" span={18}>{item.numberId}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Email</Col>
					<Col className="gutter-row" span={18}>{item.email}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Phone</Col>
					<Col className="gutter-row" span={18}>{item.phone}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Địa chỉ</Col>
					<Col className="gutter-row" span={18}>{`${item.address}, ${item?.addressFull}`}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Sinh nhật</Col>
					<Col className="gutter-row" span={18}>{renderDate(item.birthday)}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Giới tính</Col>
					<Col className="gutter-row" span={18}>{item.gender}</Col>
				</Row>
			</>
		)
	}
	const renderAttach = () => {
		return (
			<>
				<FileUpload name="file" files={files} setFiles={setFiles} onChange={onUpload}/>
				<FileList files={files} removeFile={handleRemoveFileClick}/>
			</>
		)
	}

	return (
		<div className="form">
			<Row className="mb-2" gutter={10}>
				<Col className="gutter-row" sm={24} xl={12}>
					<p className="heading">Thông tin</p>
					<Row className="mb-2" gutter={10}>
						<Col className="gutter-row" span={6}>Tên miền</Col>
						<Col className="gutter-row" span={18}><b>{`${item.domain}`}</b></Col>
					</Row>
					<Row className="mb-2" gutter={10}>
						<Col className="gutter-row" span={6}>Hợp đồng</Col>
						<Col className="gutter-row" span={18}><StatusLabel small
																		   type={item?.contract?.service?.badge}>{item?.contract?.code}</StatusLabel></Col>
					</Row>
					<Row className="mb-2" gutter={10}>
						<Col className="gutter-row" span={6}>Loại dịch vụ</Col>
						<Col className="gutter-row" span={18}><StatusLabel small
																		   type={item?.contract?.service?.badge}>{item?.contract?.service?.label}</StatusLabel></Col>
					</Row>
					<Row className="mb-2" gutter={10}>
						<Col className="gutter-row" span={6}>Loại thông tin</Col>
						<Col className="gutter-row" span={18}>{renderFor(item.for)}</Col>
					</Row>
					{item.for === 'congty' && renderCompanyInfo(item)}
					{renderCustomerInfo(item)}
				</Col>
				<Col className="gutter-row" sm={24} xl={12}>
					<p className="heading">Đính kèm</p>
					{renderAttach()}
				</Col>
			</Row>
			<div className="form-group d-flex justify-content-center modal-bottom">
				{can.edit && <Button background blue leftIcon={Icon.edit} onClick={handleEditClick}>Cập nhật</Button>}
				{
					(item.status.key === 'pending' && can.status) && (
						<Button loading={loadingStatus.success} onClick={() => handleStatusClick('success')} background
								green leftIcon={Icon.success}>Đã mua</Button>)
				}
				{
					(item.status.key !== 'cancel' && can.status) && (
						<Button loading={loadingStatus.cancel} onClick={() => handleStatusClick('cancel')} background red
								leftIcon={Icon.close}>Hủy yêu cầu</Button>)
				}
			</div>
		</div>
	)
}

export default BuyServiceFormInfo;